import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/others/services/authentication.service';

@Component({
  selector: 'app-user-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig]
})
export class UserNavRightComponent implements OnInit {

  constructor(public auth: AuthenticationService) { }

  ngOnInit() { }
}
